import Flex from "@ui-kit/layout/Flex/Flex.web";
import Text from "@ui-kit/typography/Text/Text.web";
import { MapTooltipHeaderProps } from "./MapTooltipHeader.props";
import { MAP_TOOLTIP_WIDTH } from "../constants";

export default function MapTooltipHeader({
  headerVals,
}: MapTooltipHeaderProps) {
  return (
    <Flex justifyContent="space-between" mb="2xs" minW={MAP_TOOLTIP_WIDTH}>
      {headerVals.map((headerVal) => (
        <Flex
          key={`${headerVal.id}-${headerVal.title}-${headerVal.value}`}
          direction="column"
        >
          <Text fontSize="sm" color="fg.subtle">
            {headerVal.title}
          </Text>
          <Text color="fg.inverted" letterSpacing="-0.5px" fontWeight="bold">
            {headerVal.value}
          </Text>
        </Flex>
      ))}
    </Flex>
  );
}
